import { createStore } from 'vuex'
import { userStateModule } from '@/store/userState'
import { ResponseUserStatus } from '@/services/loginService'
import createPersistedState from 'vuex-persistedstate'

export type RootState = {
  /**
   * 会計期間の開始日
   */
  accountingStartDate: string;
  /**
   * 会計期間の終了日
   */
  accountingEndDate: string;
  userStatus?: ResponseUserStatus
}

export default createStore({
  state: {
    accountingStartDate: '',
    accountingEndDate: ''
  },
  getters: {
    shouldSetDate (state) {
      return state.accountingStartDate === '' || state.accountingEndDate === ''
    }
  },
  mutations: {
    setAccountingStartDate (state, value) {
      state.accountingStartDate = value
    },
    setAccountingEndDate (state, value) {
      state.accountingEndDate = value
    }
  },
  actions: {
  },
  modules: {
    userStatus: userStateModule
  },
  plugins: [createPersistedState({
    key: 'template-report',
    storage: window.sessionStorage
  })]
})
